import { accountAPI } from "services";

export const defaultValues = {
  name: "",
  phone: "",
  address: "",
  details: "",
  photo: { url: null, loading: false, file: null },
  tag: null
};

export const validateAccountName = async (value, accountId = null) => {
  if (!value) return "Name is required";

  // Check if name exists
  const accountByName = await accountAPI.getAccountByName(value);

  if (accountByName) {
    // If it's the same account we are editing, it's valid
    if (typeof accountId === "string" && accountByName.id === accountId) return true;
    if (accountByName.get("cancelled")) return "Account with this name already closed"
    return "Account with this name already exists";
  }

  return true;
};
